import { Injectable, signal } from '@angular/core';

export interface SandboxUser { id: string; name: string; }

@Injectable({ providedIn: 'root' })
export class SandboxService {
  readonly users: SandboxUser[] = [
    { id: 'mock-user-001', name: 'Akis Dev' },
    { id: 'user-002',      name: 'Maria Papadopoulou' },
    { id: 'user-003',      name: 'Nikos Kostas' },
    { id: 'user-004',      name: 'Elena Dimitriou' },
    { id: 'user-005',      name: 'Giorgos Stavros' },
  ];

  // Pre-select first user so dashboard/vehicles show data immediately
  viewingAs = signal<string>(this.users[0].id);

  viewingAsName(): string {
    return this.users.find(u => u.id === this.viewingAs())?.name ?? '';
  }
}
